import { render, staticRenderFns } from "./SelfStoreCard.vue.js?vue&type=template&id=0063805a&scoped=true!=!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.4_@rspack+core@2.0.4_@swc+helpers@0.5.21__webpack@5.1_8ecddcfa3a7344e2ed8878aeb6f4a753/node_modules/vue-loader/lib/index.js??vue-loader-options!./SelfStoreCard.vue?vue&type=template&id=0063805a&scoped=true"
var script = {}
import style0 from "./SelfStoreCard.vue.postcss?vue&type=style&index=0&id=0063805a&prod&lang=postcss&scoped=true!=!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.4_@rspack+core@2.0.4_@swc+helpers@0.5.21__webpack@5.1_8ecddcfa3a7344e2ed8878aeb6f4a753/node_modules/vue-loader/lib/index.js??vue-loader-options!./SelfStoreCard.vue?vue&type=style&index=0&id=0063805a&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.4_@rspack+core@2.0.4_@swc+helpers@0.5.21__webpack@5.1_8ecddcfa3a7344e2ed8878aeb6f4a753/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0063805a",
  null
  
)

export default component.exports